<div class="add-container">
	<h1 class="add-title">Adaugă status cerere</h1>
	<form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Status</mat-label>
					<input type="text" matInput formControlName="name" />
					<mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Slug</mat-label>
					<input type="text" matInput formControlName="slug" />
				</mat-form-field>
			</div>
		</div>
		<div class="row">
			<div class="col-6">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Culoare</mat-label>
					<input type="color" matInput formControlName="bg_color" />
					<mat-error *ngIf="
						!form.controls['bg_color'].valid &&
						form.controls['bg_color'].touched
					">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>

			<div class="col-6 add-field">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Rank</mat-label>
					<mat-select formControlName="rank">
						<mat-option *ngFor="let rank of ranks$ | async" [value]="rank.slug">
							{{ rank.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Observații</mat-label>
					<input type="text" matInput formControlName="observations" />
				</mat-form-field>
			</div>
		</div>

		<div class="row">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
					{{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
					{{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
			<h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>